module.exports = __webpack_public_path__ + "static/media/celery.b590703e.webp";